import React, {ReactNode} from "react";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import AdminDialog, {AdminDialogProperties, AdminDialogState} from "./AdminDialog";
import AdminDialogType from "../AdminDialogType";
import Message from "../../../shared/log/Message";
import {MessageType} from "../../../shared/log/MessageInterface";
import {Administration} from "@softvision/webpdf-wsclient-9-typescript/lib/session/Administration";
import Translate from "../../../shared/translation/Translate";
import Helper from "../../../shared/components/Helper";
import Icon from "../../../shared/components/Icon";

export class RestartDialogDefinition extends AdminDialog<any, AdminDialogProperties<any>, AdminDialogState<any>> {
	public renderDialog(): ReactNode {
		let classList: Array<string> = ["restart-dialog"];
		if (this.state.submitted) {
			classList.push("submitted");
		}

		return (
			<Dialog className={classList.join(" ")} visible={this.props.visible} onHide={this.hide}
					closeOnEscape={true} header={this.renderHeader()} footer={this.renderFooter()} resizable={false}
					appendTo={document.getElementById("root")}>
				<div className="p-grid">
					{this.renderError()}
					<Helper {...this.props} type={MessageType.WARNING}>
						<Translate {...this.props} data={"dialog.admin.restart.info"} namespace={"help"}
								   markdown={true}/>
					</Helper>
					<fieldset className="p-col-12 p-grid">
						<div className="dialog-message">
							<Translate {...this.props} data="restart.message" namespace="dialog"/>
						</div>
					</fieldset>
				</div>
			</Dialog>
		);
	}

	protected renderHeader(): ReactNode {
		return (
			<div>
				<h1>
					<Icon icon={"icon-restart"}/>
					<Translate {...this.props} data="restart.title" namespace="dialog"/>
				</h1>
				<Button icon="icon icon-close" onClick={() => this.hide()}/>
				{this.renderHelpButton()}
			</div>
		);
	}

	protected renderFooter(): ReactNode {
		return (
			<div>
				<Button label={Translate.value("buttons.restart")} className="primary-button"
						icon={"icon" + (this.state.submitted ? " icon-spinner spin" : " icon-check")}
						onClick={() => this.submit()} disabled={!this.isValid()}/>
				{this.state.submitted ?
					<Button label={Translate.value("buttons.close")} icon="icon icon-close"
							onClick={() => this.hide()} className="dialog-button"/> :
					<Button label={Translate.value("buttons.cancel")} icon="icon icon-close"
							onClick={() => this.hide()} className="dialog-button"/>
				}
			</div>
		);
	}

	protected isValid(): boolean {
		if (!this.mounted || !this.props.visible) {
			return false;
		}

		return !this.state.submitted;
	}

	protected async submit(): Promise<void> {
		await super.submit();

		let administration: Administration = this.props.context.session.getAdministration();

		try {
			await administration.restart();
		} catch (exception: any) {
			if (await this.onError(exception)) {
				await this.submit();
			}
			return;
		}

		let message: Message = new Message("success.administration.restart", MessageType.SUCCESS);
		this.props.context.getPage().addMessage(message);
		this.hide();

		this.props.context.session.clearSessionToken();
		await this.props.context.session.reconnectServer();
	}

	protected getDialogType(): AdminDialogType {
		return AdminDialogType.RESTART;
	}
}

const RestartDialog = React.memo(RestartDialogDefinition,
	(prevProps: Readonly<AdminDialogProperties<any>>, nextProps: Readonly<AdminDialogProperties<any>>) => {
		if (!nextProps.visible && !prevProps.visible) {
			return true
		}

		return false;
	}
);

export default RestartDialog;